import gql from 'graphql-tag'

export const GET_ABOUT_US_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
  ) {
    getAboutPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
      }
    ) {
      hasMore
      total
      items {
        id
        titleEn
        titleKg
        titleRu
        expYear
        homeId
        isAboutPage
      }
    }
  }
`

export const GET_ABOUT_US_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getAbout (
      data: {
        id: $id
      }
    ) {
      id
      titleEn
      titleKg
      titleRu
      descriptionEn
      descriptionKg
      descriptionRu
      quoteEn
      quoteKg
      quoteRu
      expYear
      homeId
      isAboutPage
    }
  }
`

export const GET_ABOUT_US_IMAGES_QUERY = gql`
  query {
    getAboutImages {
      coverImage
      otherImages
    }
  }
`

export const GET_ALL_ABOUT_US_QUERY = gql`
  query {
    getAllAbout {
      id
      titleEn
      titleKg
      titleRu
    }
  }
`
